import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { Modal, Form, Button } from 'react-bootstrap';
import { useAppSelector, useAppDispatch } from '../../../hooks/defaultHooks';
import { modalExtra } from '../../../selectors/selectors';
import { closeModal } from '../../../store/slices/modalSlice';
import { isFetchBaseQueryError } from '../../../utils/helpers';
import { useRestoreUserMutation } from '../../user/user.service';
import { toast } from 'react-toastify';
import cls from './RestoreUser.module.scss';

interface initialValues {
  email: string;
}

const RestoreUser = () => {
  const extra = useAppSelector(modalExtra);
  const dispatch = useAppDispatch();
  const [restore] = useRestoreUserMutation();
  const closeHandler = () => dispatch(closeModal());
  const [disabled, setDisabled] = useState(false);
  const initialValues: initialValues = {
    email: '',
  };

  const formik = useFormik({
    initialValues,
    validateOnChange: false,
    onSubmit: async (values) => {
      if (extra?.email === values.email.toLocaleLowerCase()) {
        try {
          restore(extra.id as string);
          dispatch(closeModal());
          toast.success('User restored successfully');
        } catch (error) {
          if (isFetchBaseQueryError(error)) {
            if (error.status === 400) {
              toast.error('Please try again later');
            } else if (error.status === 403) {
              toast.error('Access denied');
            } else if (error.status === 404) {
              toast.error('User not found');
            }
          }
        }
      } else {
        toast.error('Invalid email');
      }
    },
  });
  useEffect(() => {
    if (formik.values.email === '') {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [formik]);
  return (
    <>
      <Modal.Header className={cls.ModalHeader} closeButton>
        <h3 className="title-3" data-testid="modal-title">
          {extra?.title}
        </h3>
      </Modal.Header>
      <Modal.Body className={cls.ModalBody}>
        <div data-testid="text-part">
          <p>
            {extra?.supportText} <strong>{extra?.textInformation}</strong>? {extra?.subSupportText}
          </p>
        </div>
        <Form
          noValidate
          onSubmit={formik.handleSubmit}
          className={cls.Form}
          data-testid="restore-user"
        >
          <div>
            <Form.Label htmlFor="email">Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              id="email"
              onChange={formik.handleChange}
              value={formik.values.email}
            />
          </div>
          <div className={cls.Buttons}>
            <Button
              type="submit"
              className={disabled ? `${cls.Button} ${cls.Disabled}` : `${cls.Button}`}
              disabled={disabled}
            >
              {extra?.actionButtonText}
            </Button>
            <Button onClick={closeHandler} className={cls.CancelButton}>
              Cancel
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </>
  );
};

export default RestoreUser;
